import './bootstrap';
import 'webfontloader';
import { createApp } from 'vue';
import '@vuepic/vue-datepicker/dist/main.css';
import { gsap, ScrollTrigger } from 'gsap/all';
import { footerPosition } from './footer';
import 'lazysizes';

gsap.registerPlugin(ScrollTrigger);

window.WebFontConfig = {
    google: {
        families: ['Noto+Sans+JP:400,700']
    }
};

document.addEventListener("DOMContentLoaded", function(event) {
    let wf = document.createElement('script');
    wf.src = 'https://ajax.googleapis.com/ajax/libs/webfont/1.6.26/webfont.js';
    wf.type = 'text/javascript';
    wf.async = 'true';
    let s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(wf, s);

    // 遅延読み込み(Lazy Load)
    if ('loading' in HTMLImageElement.prototype) {
        const mainImages = document.querySelectorAll('.wrapper img');
        mainImages.forEach((el) => {
            const src = el.getAttribute('src');
            // el.setAttribute('loading', 'lazy');
            el.setAttribute('data-src', src); // data-src属性にsrcの値をセット
            el.removeAttribute('src'); // src属性を空にする
            el.classList.add('lazyload');
        });
    }

    // リンク切れの場合、Noimageにする
    const images = document.querySelectorAll('.img img');
    images.forEach((image) => {
        image.addEventListener('error', () => {
            image.setAttribute('src', '/img/aloco_img_2.svg');
        });
    });

    // 外部リンクの場合はtarget _blankとrel noopenerをつける
    const httpLinks = Array.prototype.slice.call(document.querySelectorAll('a[href^=http]'),0);
    if(httpLinks.length) {
        //サイトのホスト名を取得
        const hostname = location.hostname;
        httpLinks.forEach(function(elm){
            //ホスト名が異なるリンク設定の場合のみ_blank系の設定を追加
            if(elm.getAttribute('href').indexOf(hostname) === -1) {
                elm.setAttribute('target','_blank');
                elm.setAttribute('rel','noopener');
            }
        });
    }

    // a要素を取得
    const el_a = document.getElementsByTagName('a');
    for (let element of el_a) {
        let target = element.getAttribute('target');
        // target属性が_blankであれば、rel属性のnoopenerを付与
        if (target === '_blank') {
            element.setAttribute('rel', 'noopener');
        }
    }
});

import axios from 'axios';
import store from './store/index';
import * as _ from 'lodash';

document.addEventListener('DOMContentLoaded', () => {
    const app = createApp({});
    const axiosInstance = axios.create({
      withCredentials: true,
    });
    app.config.globalProperties.$axios = axiosInstance;
    app.config.globalProperties.$store = store;
    app.use(store);
    app.config.globalProperties.$_ = _;

    const globalMixin = {
      updated() {
        footerPosition();
      }
    };
    app.mixin(globalMixin);

    app.component('nl2br', require('vue3-nl2br').default);
    app.component('static-header', require('./componets/StaticHeader.vue').default);
    app.component('site-side', require('./componets/Side.vue').default);
    app.component('shop-info', require('./componets/ShopInfo.vue').default);
    app.component('sort', require('./componets/Sort.vue').default);
    app.component('article-sort', require('./componets/ArticleSort.vue').default);
    app.component('coupons-list', require('./componets/CouponsList.vue').default);
    app.component('area-coupons-list', require('./componets/AreaCouponsList.vue').default);
    app.component('shop-coupons-list', require('./componets/ShopCouponsList.vue').default);
    app.component('account-delete', require('./componets/AccountDelete.vue').default);
    app.component('account-unblock', require('./componets/AccountUnBlock.vue').default);
    app.component('mypage-update', require('./componets/MypageUpdate.vue').default);
    app.component('mypage-favorite', require('./componets/MypageFavorite.vue').default);
    app.component('history', require('./componets/History.vue').default);
    app.component('post-edit', require('./componets/PostEditModal.vue').default);
    app.component('shop-card', require('./componets/ShopCard.vue').default);
    app.component('slide-photos', require('./componets/SlidePhotos.vue').default);
    app.component('reservation-button', require('./componets/ReservationButton.vue').default);
    app.component('reservation', require('./componets/Reservation.vue').default);
    app.component('contact', require('./componets/Contact.vue').default);
    app.component('review-post', require('./componets/ReviewPost.vue').default);
    app.component('file-upload', require('./componets/FileUpload.vue').default);
    app.component('review-rating', require('./componets/ReviewRating.vue').default);
    app.component('review-edit', require('./componets/ReviewEdit.vue').default);
    app.component('signup-complete', require('./componets/SignupComplete.vue').default);
    app.component('logout', require('./componets/logout.vue').default);
    app.component('signup-appeal', require('./componets/SignupAppeal.vue').default);
    app.component('like-button', require('./componets/LikeButton.vue').default);
    app.component('like-count', require('./componets/LikeCount.vue').default);
    app.component('review-list-parts', require('./componets/ReviewListParts.vue').default);
    app.component('review-stars', require('./componets/ReviewStars.vue').default);
    app.component('community-detail', require('./componets/CommunityDetail.vue').default);
    app.component('community-comment', require('./componets/CommunityComment.vue').default);
    app.component('community-edit', require('./componets/CommunityEditModal.vue').default);
    app.component('community-del', require('./componets/CommunityDelete.vue').default);
    app.component('community-post', require('./componets/CommunityPostModal.vue').default);
    app.component('community-list-parts', require('./componets/CommunityListParts.vue').default);
    app.component('mypage-community-list', require('./componets/MypageCommunityList.vue').default);
    app.component('mypage-community-comment', require('./componets/MypageCommunityComment.vue').default);
    app.component('mypage-review-list', require('./componets/MypageReviewList.vue').default);
    app.component('shop-signup-appeal', require('./componets/ShopSignupAppeal.vue').default);
    app.component('community-comment-signup-appeal', require('./componets/CommunityCommentSignupAppeal.vue').default);
    app.component('post-complete', require('./componets/postComplete.vue').default);
    app.component('bottom-navigation-bar', require('./componets/BottomNavigationBar/BottomNavigationBar.vue').default);
    app.component('share-button', require('./componets/ShareButton.vue').default);
    app.component('mypage-file-upload', require('./componets/MypageFileUpload.vue').default);
    app.component('like-signup-appeal', require('./componets/LikeSignupAppeal.vue').default);
    app.component('mypage-like-button', require('./componets/MypageLikeButton.vue').default);
    app.component('photo-category-list', require('./componets/PhotoCategoryList.vue').default);
    app.component('menu-category-list', require('./componets/MenuCategoryList.vue').default);
    app.component('shop-modal', require('./componets/ShopModal.vue').default);
    app.component('search-modal', require('./componets/SearchModal.vue').default);
    app.component('shop-detail-menu', require('./componets/ShopDetailMenu.vue').default);
    app.component('content-info', require('./componets/ContentInfoModal.vue').default);
    app.component('like-list', require('./componets/LikeList.vue').default);

    app.mount('#app');
})
